import TabPage from "./../../factories/tab-page";
import "./../../bindings/bao-date-time-box";
import "./../../bindings/bao-date-time-picker";
import "./../../bindings/bao-pager";
import BaseViewModel from "./../../factories/base-view-model";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import * as moment from "moment";
import BaoDialog from "./../../factories/bao-dialog";
class MailHistory extends BaseViewModel {
    Bao = Bao;
    Recipient: KnockoutObservable<string> = ko.observable<string>("");
    FromDate: KnockoutObservable<string> = ko.observable<string>();
    ToDate: KnockoutObservable<string> = ko.observable<string>();
    Sorting: KnockoutObservableArray<any> = ko.observableArray<any>([]);
    PageIndex: KnockoutObservable<number> = ko.observable<number>(0);
    TotalRows: KnockoutObservable<number> = ko.observable<number>(0);
    PageSize: KnockoutObservable<number> = ko.observable<number>(25);
    MailCollection: KnockoutObservableArray<any> = ko.observableArray<any>([]);
    constructor(tabPage: TabPage) {
        super(tabPage);
        this.TabPage = tabPage;
        Bao.Session.GetMessage("MailHistoryTabTitle").then((tabTitle) => {
            this.TabPage.Title(tabTitle);
        });
        this.Sorting.subscribe(() => {
            this.GetMailCollection();
        });
        this.PageIndex.subscribe(() => {
            this.GetMailCollection();
        });
    }
    GetMailCollection() {
        this.TabPage.IsLoading(true);
        if (Bao.Utils.String.IsNullOrEmpty(this.FromDate()) || Bao.Utils.String.IsNullOrEmpty(this.ToDate())) {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        else {
            Bao.post("Checkware/MailHistory/GetMailCollection", JSON.stringify({
                recipient: this.Recipient(),
                fromDate: this.FromDate(),
                toDate: this.ToDate(),
                pageIndex: this.PageIndex(),
                pageSize: this.PageSize(),
                sorting: this.Sorting()
            })).then((result) => {
                if (result.Models != null) {
                    this.MailCollection([]);
                    this.TotalRows(result.TotalRows);
                    this.MailCollection(result.Models);
                }
            }).always(() => {
                this.TabPage.IsLoading(false);
            });
        }
    }
    init(): JQueryPromise<void> {
        let def = $.Deferred<void>();
        Bao.post("Checkware/MailHistory/GetDateValues").then((result) => {
            this.FromDate(result.FromDate);
            this.ToDate(result.ToDate);
        });
        return def.resolve().promise();
    }
}
export default MailHistory;